import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_System back_black",
  "use": "ico_System back_black-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico_System back_black\">\n    <path data-name=\"Union 9\" d=\"m2.141 12.001 9.362-8.025.728.849-7.72 6.617H22v1.118H4.511l7.72 6.617-.728.849z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol